module.exports = __webpack_public_path__ + "img/productSatellite_27.e3a5fdae.png";